"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItem = void 0;
var react_1 = __importDefault(require("react"));
var NavigationContext_1 = require("./NavigationContext");
var scrollTo_1 = require("../Util/scrollTo");
var TelemetryContext_1 = require("../Telemetry/TelemetryContext");
var react_2 = require("react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var PubSub_1 = require("../PubSub/PubSub");
exports.MenuItem = (0, react_2.forwardRef)(function MenuItem(_a, ref) {
    var label = _a.label, blockId = _a.blockId;
    var navigationContext = (0, NavigationContext_1.useNavigationContext)();
    var track = (0, TelemetryContext_1.useTelemetry)().track;
    var scrollToBlock = function () {
        var blockClass = ".project-block--id-".concat(blockId);
        (0, scrollTo_1.scrollTo)(blockClass);
        if (window.innerWidth < 700) {
            PubSub_1.PubSub.publish("qwilr:nav-drawer-toggled", { isOpen: false });
        }
        track("Navigation Used", { feature_used: "navigated to block" });
    };
    var button = (react_1.default.createElement(kaleidoscope_1.MenuItem, { onClick: scrollToBlock, ref: ref, "data-block-id": blockId }, label));
    if (navigationContext.MenuItemWrapper) {
        return (react_1.default.createElement(navigationContext.MenuItemWrapper, { label: label, blockId: blockId }, button));
    }
    return button;
});
